interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={`mb-8 md:mb-10 ${align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-primary-600 mb-3">
        <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight mb-3">{title}</h2>
      {desc && <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">{desc}</p>}
    </div>
  );
}